import {CreateForm} from "./create-form";

export const CreatePost = () => {

    return (
        <div className="create-post">
            <CreateForm/>
        </div>
    )
}